module.exports = __webpack_public_path__ + "static/media/white.38e23262.jpg";